<span dropdown *transloco="let t">
  <a class="nav-link dropdown-toggle" id="navbarNotificationsDropdown" role="button" dropdownToggle
    (click)="false" [attr.aria-label]="t('navigation.notifications')" aria-expanded="false"
    aria-controls="navbarNotificationsDropdown-dropdown">
    <i class="fa-solid fa-bell"></i>
    @if (unreadCount > 0) {
      <span class="badge badge-pill badge-primary ml-1">{{ unreadCount }}</span>
    }
  </a>
  <ul id="navbarNotificationsDropdown-dropdown" *dropdownMenu class="dropdown-menu" role="menu"
    aria-labelledby="navbarNotificationsDropdown">
    @for (notification of notifications; track notification.id) {
      <li>
        <a class="dropdown-item" (click)="open(notification)">
          <span>
            <span class="icon-holder">
              <i [class]="'fa-solid fa-info'"></i>
            </span>
            @if (notification.label.text) {
              <span>{{ notification.label.text }}</span>
            } @else if (notification.label.translationKey) {
              <span *transloco="let tl; scope: notification.label.translationScope ?? undefined">{{ tl(notification.label.translationKey) }}</span>
            }
            @if (notification.context; as context) {
              &nbsp;|&nbsp;
              @if (context.text) {
                <span>{{ context.text }}</span>
              } @else if (context.translationKey) {
                <span *transloco="let tc; scope: context.translationScope ?? undefined">{{ tc(context.translationKey) }}</span>
              }
            }
            @if (notification.teaser) {
              <br>
              <span>{{ notification.teaser }}</span>
            }
          </span>
        </a>
      </li>
    }
    @if (notifications.length > 0) {
      <li><hr class="dropdown-divider"></li>
    }
    <li>
      <a class="dropdown-item" [routerLink]="['/notifications']">{{ t('common.see_all') }}</a>
    </li>
  </ul>
</span>
